import {createContext} from 'react'
import type {PropsWithChildren} from 'react'

export type UserNameDisplayConfiguration = 'handle' | 'name_handle'

export const UserNameDisplayContext = createContext<UserNameDisplayConfiguration>('handle')

const GRAPHQL_TO_CONTEXT_MAP: Record<string, UserNameDisplayConfiguration> = {
  NAME_HANDLE: 'name_handle',
  NAME_AND_HANDLE: 'name_handle',
  HANDLE: 'handle',
}

// Populate the username display configuration context for this component's children from an external value, such
// as provided by the RepositoryOwner.userNameDisplayConfiguration GraphQL field.
export function UserNameDisplayContextProvider({value, children}: PropsWithChildren<{value?: string}>) {
  const mapped: UserNameDisplayConfiguration = (value && GRAPHQL_TO_CONTEXT_MAP[value.toUpperCase()]) || 'handle'

  return <UserNameDisplayContext value={mapped}>{children}</UserNameDisplayContext>
}

try{ UserNameDisplayContext.displayName ||= 'UserNameDisplayContext' } catch {}
try{ UserNameDisplayContextProvider.displayName ||= 'UserNameDisplayContextProvider' } catch {}